// src/components/ValencePage.tsx
import React, { useState } from 'react';
import { Container, Image, Button } from 'react-bootstrap';
import valenceImg from '../assets/Valence.png';

const gap = 6;

interface ValencePageProps {
  onFinish: (value: number) => void;
  languageData: any;
}

const ValencePage: React.FC<ValencePageProps> = ({ onFinish, languageData }) => {
  const [selected, setSelected] = useState<number | null>(null);

  const handleSelect = (value: number) => {
    setSelected(value);
  };

  const handleContinue = () => {
    if (selected !== null) {
      onFinish(selected+1);
    }
  };

  return (
    /* 1️⃣  Container: remove horizontal padding that Bootstrap adds */
    <Container fluid className="px-0 text-center" style={{ marginTop: '3%' }}>
      <h3 className="display-6" style={{ marginBottom: '20px' }}>
        {languageData.instructionValence}
      </h3>

      {/* 2️⃣  Scale the picture up to (at most) 90 % of the viewport width */}
      <Image
        src={valenceImg /* or emotionImg */}
        fluid
        alt="Valence scale"
        style={ {marginBottom: 20}}
        className="scale-img"
      />

      {/* 3️⃣  Ten fully responsive squares */}
      <div
        style={{
          /* full width, centred */
          width: '100%',
          maxWidth: 450,          // stops them from being huge on desktop
          //margin: `0 auto ${gap * 4}px`,
          display: 'grid',
          justifyItems: 'center',
          /* each of the 10 tracks shrinks to fit    ↓ makes the 1fr tracks
            even smaller than the content if needed */
          gridTemplateColumns: 'repeat(9, minmax(0, 1fr))',
          gap,
          marginBottom: '5vh'
        }}
      >
        {Array.from({ length: 9 }, (_, idx) => (
          <div
            key={idx}
            onClick={() => handleSelect(idx)}
            style={{
              /* fluid square – height follows width */
              width: '100%',
              aspectRatio: '1/1',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '1px solid #000',
              borderRadius: 4,
              cursor: 'pointer',
              fontSize: '4.5vw',       // scales with screen, clamped below
              maxWidth: 50,            // keeps desktop tidy
              maxHeight: 50,
              background: selected === idx ? '#0d6efd' : '#fff',
              color:        selected === idx ? '#fff'   : '#000',
            }}
          >
            {idx + 1}
          </div>
        ))}
      </div>

      {/* 4️⃣  Continue / Next button */}
      <Button
        disabled={selected === null}
        style={{ width: 200 /* fixed width looks good centred */ }}
        onClick={handleContinue}
      >
        {languageData.nextBtn}
      </Button>
    </Container>
  );
};

export default ValencePage;
